import PropTypes from 'prop-types';
import React from 'react';
import {
  Modal,
  ModalButtons,
  ModalContent,
  Button,
  ProgressBar,
  withForm,
  Label,
  TextField,
} from 'mw-style-react';
import AppUtils from '@control-front-end/utils/utils';
import { NOTIFY_LEVEL, SHOW_NOTIFY } from 'constants';
import { CREATE_LAYER } from '@control-front-end/common/constants/graphLayers';
import { MANAGE_GRAPH_FOLDER } from '@control-front-end/common/constants/graphFolders';
import { BULK_ADD_TO_GRAPH } from '@control-front-end/common/constants/graphActors';
import Yup from 'yup';
import useIntl from 'useIntl';
import mes from './intl';
// eslint-disable-next-line no-unused-vars
import sModal from '../../Modal.scss'; // NOSONAR
// eslint-disable-next-line no-unused-vars
import sLocal from './SaveLayer.scss'; // NOSONAR

function SaveLayerBase(props) {
  const {
    values,
    errors,
    visibility,
    onClose,
    handleSubmit,
    handleOnChange,
    isSubmit,
  } = props;
  const t = useIntl();

  return (
    <Modal
      styleName="sModal.modal"
      visibility={visibility}
      onClose={onClose}
      label={t(mes.saveAsLayer)}
    >
      <ModalContent styleName="sModal.modal__content sLocal.content">
        <div styleName="sLocal.row">
          <Label value={t(mes.layerProgress)} styleName="sLocal.row__label" />
          <Label value={t(mes.enterLayerName)} />
          <TextField
            styleName="sModal.textfield sLocal.row__field"
            autoFocus={true}
            autoSelect={true}
            id="name"
            placeholder={t(mes.filterNamePlaceholder)}
            bordered={true}
            size="large"
            value={values.name || ''}
            helperText={errors.name ? t(mes[errors.name]) : ''}
            error={!!errors.name}
            onChange={handleOnChange}
          />
        </div>
      </ModalContent>
      <ModalButtons styleName="sModal.modal__buttons">
        <Button
          label={t(mes.saveAndContinue)}
          size="large"
          onClick={handleSubmit}
          visibility={isSubmit ? 'disabled' : 'visible'}
        />
        <ProgressBar
          styleName="sModal.modal__loader"
          type="circle"
          size="small"
          visibility={isSubmit ? 'visible' : 'hidden'}
        />
      </ModalButtons>
    </Modal>
  );
}

const SaveLayer = withForm(
  {
    mapPropsToValues(props) {
      const formData = props.data || {};
      return {
        name: formData.name || 'New layer',
        startLayerId: formData.startLayerId,
        layerActions: formData.layerActions || [],
      };
    },
    yup: Yup.object().shape({
      name: Yup.string().required('field_required'),
    }),
    handleSubmit: (values, dispatch, formActions, props) => {
      formActions.onClose = props.onClose;
      const { name } = values;
      const { graphFolderId, nodes: newNodes, edges: newEdges } = props.data;
      dispatch({
        type: CREATE_LAYER.REQUEST,
        payload: { name, graphFolderId, isNew: false },
        callback: (layer) => {
          dispatch({
            type: MANAGE_GRAPH_FOLDER.REQUEST,
            payload: {
              id: graphFolderId,
              actions: [{ action: 'create', ...layer }],
              manageLayers: false,
            },
            callback: () => {
              const nodes = newNodes
                .filter((i) => i.status !== 'removed')
                .map((i) => i.data);
              const edges = newEdges
                .filter((i) => i.status !== 'removed')
                .map((i) => i.data);
              dispatch({
                type: BULK_ADD_TO_GRAPH.REQUEST,
                payload: { layerId: layer.id, nodes, edges },
                callback: () => props.callback({ id: layer.id, graphFolderId }),
              });
            },
          });
          dispatch({
            type: SHOW_NOTIFY.REQUEST,
            payload: {
              id: AppUtils.createRid(),
              type: NOTIFY_LEVEL.SUCCESS,
              label: 'Layer was created',
            },
          });
        },
      });
      props.onClose();
    },
  },
  SaveLayerBase
);

SaveLayerBase.propTypes = {
  visibility: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  handleSubmit: PropTypes.func,
  handleOnChange: PropTypes.func,
  dispatch: PropTypes.func, // eslint-disable-line react/no-unused-prop-types
  isSubmit: PropTypes.bool,
  values: PropTypes.object,
  errors: PropTypes.object,
  data: PropTypes.object, // eslint-disable-line react/no-unused-prop-types
};

export default SaveLayer;
